import { render, staticRenderFns } from "./TableNum.vue?vue&type=template&id=534c6e0b&scoped=true&"
import script from "./TableNum.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableNum.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TableNum.vue?vue&type=style&index=0&id=534c6e0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c6e0b",
  null
  
)

export default component.exports